import { render } from "./FormModal.vue?vue&type=template&id=70bff9c0&ts=true"
import script from "./FormModal.vue?vue&type=script&lang=ts"
export * from "./FormModal.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__